import React from "react"
import { useTranslation } from "react-i18next"

import { CalendarFilter } from "~/components/FilterWrapper/components/CalendarFilter/CalendarFilter"
import { EmptyFilter } from "~/components/FilterWrapper/components/EmptyFilter/EmptyFilter"
import { NameFilter } from "~/components/FilterWrapper/components/NameFilter/NameFilter"
import { FilterPreloaderWrapper } from "~/components/FilterWrapper/components/PreloaderWrapper/PrealoderWrapper"
import { ShowMore } from "~/components/FilterWrapper/components/ShowMore/ShowMore"
import { FilterWrapper } from "~/components/FilterWrapper/FilterWrapper"

import { Cell, TopCell } from "../Cells/Cells"
import styles from "./index.module.css"

export const Filter: React.FC = () => {
  const { t } = useTranslation()

  return (
    <FilterWrapper url={"/documents/elements"}>
      {({ items }) => (
        <>
          <div className={styles.Filters}>
            <div className={styles.Grid}>
              <NameFilter placeholder={t("docs.filterPlaceholder")} />
              <CalendarFilter />
            </div>
          </div>
          {items.length === 0 ? (
            <EmptyFilter />
          ) : (
            <>
              <TopCell />

              <FilterPreloaderWrapper className={styles.Items}>
                {items.map(({ id, name, date, file }) => {
                  if (file) {
                    return <Cell key={id} date={date} file={file} name={name} />
                  }
                })}
              </FilterPreloaderWrapper>

              <ShowMore />
            </>
          )}
        </>
      )}
    </FilterWrapper>
  )
}
